import { map, merge } from "rxjs";
import { ServerResponseStatus } from "../../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
class BaseRealtimeService {
  _subscriptionMappings;
  _client;
  _activeSubscriptions = {};
  constructor(client, subscriptionMapping) {
    this._client = client;
    this._subscriptionMappings = subscriptionMapping;
  }
  subscribe(payload) {
    const subscriptionFactory = this._subscriptionMappings[payload.entity];
    for (const { type, args, key } of payload.triggers) {
      let subscriber = this._activeSubscriptions[key];
      if (!subscriber) {
        const request = subscriptionFactory?.getSubscription(type);
        if (request) {
          subscriber = this._client.subscribeTemp(request, key, args).pipe(
            map((r) => {
              const mapResponse = subscriptionFactory.getResponseMapper(type);
              return {
                ...r,
                requestPayload: { ...payload, triggers: [{ type, args, key }] },
                responsePayload: mapResponse && r.responsePayload ? mapResponse(r.responsePayload) : []
              };
            })
          );
          this._activeSubscriptions[key] = subscriber;
        }
      }
    }
    return merge(...this.getSubscriptionsArray());
  }
  unsubscribe(payload) {
    const potentialUnsubscribersKeys = payload.triggers.map((trigger) => trigger.key);
    potentialUnsubscribersKeys.forEach((key) => {
      delete this._activeSubscriptions[key];
    });
    return this._client.unsubscribe(potentialUnsubscribersKeys).pipe(
      map(() => {
        return {
          requestPayload: payload,
          responsePayload: null,
          status: ServerResponseStatus.Success
        };
      })
    );
  }
  getSubscriptionsArray() {
    return Object.values(this._activeSubscriptions);
  }
}
export {
  BaseRealtimeService
};
//# sourceMappingURL=BaseRealtimeService.js.map
